if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      // TIERED DISCOUNTS - splitting vars into separate line items:
      // check current variant against cart line items - if it exists, 
      // then add a hidden line item prop to force this variant to be added
      // as a separate line item
      this.checkForDuplicateVariants(this.querySelector('[name=id').value);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // This random value is there so if the same product is added twice it would show up as 2 separate products
      const randomVariantIndex = Math.floor(1000 + Math.random() * 9000);

      // Append or override the _variantIndex with the random value
      formData.set('properties[_variantIndex]', randomVariantIndex);
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.checkForDuplicateVariants(this.querySelector('[name=id').value);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    checkForDuplicateVariants(id) {
      // get cart items
      // check for current variant
      fetch('/cart.js')
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          const matchingVariants = response.items.filter(item => item.variant_id === parseInt(id));

          this.handleLineItemProp(matchingVariants.length);
          
        })
        .catch((e) => {
          console.error(e);
        })
    }

    handleLineItemProp(index) {
      const propInput = this.querySelector('[name="properties[_variantIndex]"]');
      if (!propInput) {
        return
      }

      propInput.value = index.toString();
    }
  });
}
